import { useEffect, useState } from 'react';

const useIsElementVisible = (ref: React.RefObject<HTMLElement>) => {
	const [isVisible, setIsVisible] = useState(false);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		const checkVisibilityMobile = () => {
			if (!ref.current) return;

			const rect = ref.current.getBoundingClientRect();
			const windowHeight =
				window.innerHeight || document.documentElement.clientHeight;

			const visibleTop = Math.max(0, rect.top);
			const visibleBottom = Math.min(windowHeight, rect.bottom);

			const visibleHeight = Math.max(0, visibleBottom - visibleTop);
			const percentVisible = (visibleHeight / rect.height) * 100;
			
			const percentOfWindow = (visibleHeight / windowHeight) * 100;

			const isElementVisible = percentVisible >= 70 || percentOfWindow >= 70;

			setIsVisible(isElementVisible);
		};

		checkVisibilityMobile();

		window.addEventListener('scroll', checkVisibilityMobile, {
			passive: true,
		});
		window.addEventListener('resize', checkVisibilityMobile, {
			passive: true,
		});

		const observer = new MutationObserver(() => {
			if (ref.current) {
				checkVisibilityMobile();
			}
		});

		observer.observe(document.body, { childList: true, subtree: true });

		return () => {
			window.removeEventListener('scroll', checkVisibilityMobile);
			window.removeEventListener('resize', checkVisibilityMobile);
			observer.disconnect();
		};
	}, [ref, isMobile]);

	return isVisible;
};

export default useIsElementVisible;
